const config = {
  url: process.env.REACT_APP_HAPI_URL || 'http://0.0.0.0:3005/api/'
}

export default config
